import { useState } from "react";
import Container from "../../../../../components/Container/Container";
import toast from "react-hot-toast";

const ProgrammeHeader = ({
  urlPromoteur = null,
  promoteurAccesses = [],
  userSecteurs = [],
}) => {
  const [showInfo, setShowInfo] = useState(false);

  const handleInfoClick = () => {
    setShowInfo(!showInfo);
  };
  const headerList = [
    {
      title: "Programme",
      link: "#progHero",
      icon: "",
    },
    {
      title: "Disponibilités",
      link: "#disponibilite",
      icon: "",
    },
    {
      title: "Lots",
      link: "#lots",
      icon: "",
    },
    {
      title: "Documents",
      link: "#documents",
      icon: "",
    },
    {
      title: "Quartier",
      link: "#quartier",
      icon: "",
    },
    {
      title: "Responsable Programme",
      link: "#responsableProgramme",
      icon: "",
    },
    /* {
      title: "Extranet promoteur",
      link: urlPromoteur,
      icon: "./icons/extranet.svg",
    }, */
  ];
  const userSecteursNames = userSecteurs.map((secteur) => secteur.name);

  return (
    <Container className="p-0 ">
      <div className="d-flex bg-white radius5 headerContainer align-items-center justify-content-between">
        {headerList.map((item) => (
          <a
            key={item.title}
            href={item.link}
            className="d-flex align-items-center gap10 pink px-20"
          >
            {item.icon && <img src={item.icon} alt={item.title} />}
            <p className="fs16 semibold" title={item.link || "Pas disponible"}>
              {item.title}
            </p>
          </a>
        ))}
        <a
          href={urlPromoteur}
          target="_blank"
          className={
            urlPromoteur
              ? "radius5 d-flex align-items-center gap10 pink fs16 semibold"
              : "radius5 d-flex align-items-center gap10 softerGrey fs16 semibold pointer-none"
          }
        >
          <img
            src={
              urlPromoteur ? "./icons/extranet.svg" : "./icons/extranetOff.svg"
            }
            alt=""
          />
          Extranet promoteur
        </a>
        <div className="position-relative">
          <img
            src="./icons/info_icon.svg"
            alt=""
            height={20}
            width={20}
            className="cursor-pointer infoBulb"
            onClick={handleInfoClick}
          />
          <div className={showInfo ? "infoPopUp" : "d-none"}>
            {promoteurAccesses.filter((access) =>
              userSecteursNames.includes(access.secteur.name)
            ).length ? (
              promoteurAccesses
                .filter((access) =>
                  userSecteursNames.includes(access.secteur.name)
                )
                .map((access) => (
                  <div key={access.documentId} className="d-flex flex-column">
                    <p className="fs14 semibold">
                      Secteur:{" "}
                      <span className="fs14 regular">
                        {" "}
                        {access.secteur.name}
                      </span>{" "}
                    </p>
                    <p>
                      <span className="fs14 semibold">
                        Login:
                        <span className="fs14 regular"> {access.login}</span>
                        <span className="cursor-pointer ms-2 ">
                          <img
                            src="./icons/copy.svg"
                            alt=""
                            className="hoverEffect "
                            onClick={() => {
                              navigator.clipboard.writeText(access.login);
                              toast.success("Login copié");
                            }}
                            title="Copier le login"
                            height={16}
                            width={16}
                          />
                        </span>
                      </span>
                    </p>
                    <p>
                      <p className="fs14 semibold">
                        Password:
                        <span className="fs14 regular"> {access.password}</span>
                        <span className="cursor-pointer ms-2">
                          <img
                            src="./icons/copy.svg"
                            alt=""
                            className=" hoverEffect "
                            onClick={() => {
                              navigator.clipboard.writeText(access.password);
                              toast.success("MDP copié");
                            }}
                            title="Copier le mot de passe"
                            height={16}
                            width={16}
                          />
                        </span>
                      </p>
                    </p>
                  </div>
                ))
            ) : (
              <p className="fs14 regular">Aucun accès disponible</p>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ProgrammeHeader;
